// extracted by mini-css-extract-plugin
module.exports = {"easyToRead":"easyToRead_easyToRead__lfc_t"};